import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';

import { OrderNotFoundError } from '../../domain/errors/order-not-found.error';
import { UpdateShippingAddressError } from '../../domain/errors/update-shipping-address.error';
import { UpdatableShippingOrder } from '../../domain/models/update-order-shipping-link.models';
import { OrderRepositoyInterface } from '../../domain/ports/secondary/order-repository.interface';

import { ItxOrderTO, ItxShippingBundleTO } from './api-order-repository.models';

import { LanguageId, StoreId } from '@core/domain/types';
import { ResultObject } from '@core/domain/types/result-object.type';
import { HttpRequestsService } from '@core/services/http-requests/http-requests.service';

export class ApiOrderRepository implements OrderRepositoyInterface {
    constructor(
        private readonly http: HttpClient,
        private readonly requestService: HttpRequestsService,
    ) {}

    public updateOrderShippingAddress(
        storeId: StoreId,
        languageId: LanguageId,
        order: UpdatableShippingOrder,
        selectedAddress
    ): Observable<ResultObject<UpdateShippingAddressError, undefined>> {
        const slug = `order/store/${storeId}/order/${order.id}/edit/shipping`;

        const url = this.requestService.requestUrl(slug, languageId.toString());

        const payload: ItxShippingBundleTO = {
            shippingMethodId: order.shipping.shippingMethodId,
            dbcode: order.shipping.dbcode,
            kind: order.shipping.kind,
            shippingData: {
                addressId: selectedAddress.id,
            },
        };

        return this.http.post<ItxOrderTO>(url, payload).pipe(
            map((_response) => {
                return {
                    success: true,
                };
            }),
            catchError((error) => {
                return of({
                    success: false,
                    error: {
                        description: error.error?.description,
                    } as unknown as UpdateShippingAddressError,
                });
            }),
        );
    }

    public getOrderById(
        storeId: StoreId,
        languageId: LanguageId,
        orderId: number
    ): Observable<ResultObject<OrderNotFoundError, UpdatableShippingOrder>> {
        const slug = `order/store/${storeId}/order/${orderId}`;

        const url = this.requestService.requestUrl(slug, languageId.toString());

        return this.http.get<ItxOrderTO>(url).pipe(
            map((response) => {
                return {
                    success: true,
                    value: {
                        id: response.id,
                        status: response.status,
                        shipping: {
                            shippingMethodId: response.shipping.shippingMethodId,
                            dbcode: response.shipping.dbcode,
                            kind: response.shipping.kind,
                            shippingData: {
                                ...response.shipping.shippingData.addressId
                                    ? { addressId: response.shipping.shippingData.addressId }
                                    : {},
                                ...response.shipping.shippingData.addressId
                                    ? { physicalStoreId: response.shipping.shippingData.addressId }
                                    : {},
                            },
                        },
                    },
                };
            }),
            catchError((error) => {
                return of({
                    success: false,
                    error: {
                        description: error.error?.description,
                    } as unknown as OrderNotFoundError,
                });
            }),
        );
    }
}
